import { jsx } from 'react/jsx-runtime';
import 'date-fns-tz';
import 'clsx';
import 'tailwind-merge';
import '@radix-ui/react-label';
import '../components/ui/alert.js';
import '@radix-ui/react-avatar';
import '../components/ui/badge.js';
import 'lucide-react';
import 'react';
import 'react-day-picker';
import '../components/ui/button.js';
import '../components/ui/chart.js';
import '@radix-ui/react-checkbox';
import '@radix-ui/react-collapsible';
import 'cmdk';
import '@radix-ui/react-dialog';
import '@radix-ui/react-popover';
import 'vaul';
import '@radix-ui/react-dropdown-menu';
import '@radix-ui/react-progress';
import '../components/ui/radio-group.js';
import '@radix-ui/react-select';
import '../components/ui/time-input.js';
import '@radix-ui/react-separator';
import '../components/ui/sidebar.js';
import 'react-toastify';
import '@radix-ui/react-switch';
import '@radix-ui/react-tabs';
import '@radix-ui/react-tooltip';
import '@clerk/clerk-react';
import '../lib/toast.js';
import 'react-router-dom';
import '../contexts/AppContext.js';
import '../contexts/OrganizationContext.js';
import 'axios';
import '@tanstack/react-query';
import '../components/page-layout/FormPageLayout.js';
import '../components/form/RichTextEditor.js';
import '../components/crud/CrudDetailView.js';
import '../components/crud/CrudFormView.js';
import '../contexts/SidebarContext.js';
import '../contexts/ThemeContext.js';
import '@dnd-kit/core';
import '@dnd-kit/sortable';
import '@dnd-kit/utilities';
import 'recharts';
import { CommonComponentsDemo } from '../pages/_/demos/common/CommonComponentsDemo.js';
import { DemoIndex } from '../pages/_/demos/DemoIndex.js';
import { PageLayoutDemo } from '../pages/_/demos/layout/PageLayoutDemo.js';

/**
 * Demo routes for the frontend package
 * Import this in your apps/client router configuration
 */
const demoRoutes = [
    {
        path: '/_/demos',
        element: jsx(DemoIndex, {}),
    },
    {
        path: '/_/demos/layout',
        element: jsx(PageLayoutDemo, {}),
    },
    {
        path: '/_/demos/common',
        element: jsx(CommonComponentsDemo, {}),
    },
];
/**
 * Helper function to add demo routes to an existing router configuration
 * @param existingRoutes - Your existing route configuration
 * @returns Combined routes with demo routes added
 */
function withDemoRoutes(existingRoutes) {
    return [...existingRoutes, ...demoRoutes];
}

export { demoRoutes, withDemoRoutes };
//# sourceMappingURL=demoRoutes.js.map
